import { GetCurrentLoginInformations } from "./dto/getCurrentLoginInformations"
import http from "../httpService"
import {
  AppSettingConfiguration,
  HostSettingConfiguration,
} from "@models/global"

declare let abp: any

const USER_INFO_COOKIE = "userInfo"

/**
 * Trước đây cookie userInfo được ghi mà không truyền path, nên trình duyệt tự gán
 * default-path theo thư mục của URL đang mở (/contract/detail, /booking, ...).
 * Mỗi route vì thế đẻ ra một bản userInfo riêng chứa nguyên JSON user; máy dùng lâu
 * tích tụ hàng chục bản, làm phình cookie jar và đẩy các cookie khác (đáng chú ý là
 * enc_auth_token) ra khỏi giới hạn của trình duyệt.
 * Hàm này xoá các bản cũ theo mọi path-prefix của URL hiện tại trước khi ghi lại
 * đúng một bản duy nhất ở path "/".
 */
function purgeLegacyUserInfoCookies(): void {
  const paths: (string | undefined)[] = [undefined, "/"]
  let currentPath = ""
  window.location.pathname
    .split("/")
    .filter(Boolean)
    .forEach((segment) => {
      currentPath += `/${segment}`
      paths.push(currentPath)
    })

  paths.forEach((path) => abp.utils.deleteCookie(USER_INFO_COOKIE, path))
}

class SessionService {
  public async getCurrentLoginInformations(): Promise<GetCurrentLoginInformations> {
    const result = await http.get(
      "api/services/app/Session/GetCurrentLoginInformations",
      {
        headers: {
          "Abp.TenantId": abp.multiTenancy.getTenantIdCookie(),
        },
      }
    )
    purgeLegacyUserInfoCookies()
    abp.utils.setCookieValue(
      USER_INFO_COOKIE,
      JSON.stringify(result.data.result?.user ?? {}),
      new Date(new Date().getTime() + 5 * 365 * 86400000), // 5 year
      "/"
    )
    return result.data.result
  }

  public async getWebConfiguration(): Promise<AppSettingConfiguration> {
    const result = await http.get(
      "api/services/app/Configuration/GetWebConfiguration"
    )
    return AppSettingConfiguration.assign(result.data.result)
  }

  public async getHostSetting(): Promise<HostSettingConfiguration> {
    const result = await http.get(
      "api/services/app/HostSettings/GetAllSettings"
    )
    return result.data.result
  }
  public async changeHostSetting(body): Promise<HostSettingConfiguration> {
    const result = await http.put(
      "api/services/app/HostSettings/UpdateAllSettings",
      body
    )
    return result.data.result
  }

  public async updateUsername(body) {
    const result = await http.put(
      "api/services/app/Session/UpdatePhoneNumber",
      body
    )
    return result.data.result
  }

  public async setDefaultProject(projectId: number | null): Promise<void> {
    await http.post("api/services/app/Session/SetDefaultProject", {
      projectId,
    })
  }
}

export default new SessionService()
